<template>
    <div>
    <div>

      
      <div class="grid grid-cols-6 gap-6">
        <div class="col-span-6 border-gray-200 lg:pr-6 lg:border-r lg:col-span-2">
          <form v-on:submit.prevent="onSubmit">
          <div class="flex justify-between">
            <h3 class="text-lg font-medium leading-6 text-gray-900">Ordinazione hotel</h3>
                    <span 
                    @click="toogle()"
                    :class="this.form.enable ? 'bg-indigo-600' : 'bg-gray-200'"
                    role="checkbox" 
                    tabindex="0" 
                    aria-checked="false" 
                    class="relative flex-shrink-0 inline-block h-6 transition-colors duration-200 ease-in-out bg-gray-200 border-2 border-transparent rounded-full cursor-pointer w-11 focus:outline-none focus:shadow-outline">
                      <span aria-hidden="true"  :class="this.form.enable ? 'translate-x-5' : 'translate-x-0'" class="inline-block w-5 h-5 transition duration-200 ease-in-out transform translate-x-0 bg-white rounded-full shadow"></span>
                    </span>
                </div>
                <p class="w-64 max-w-full mt-1 text-sm leading-5 text-gray-500">
                  Per ciascun pasto indica se la prenotazione deve essere effettuata il giorno stesso oppure quello precedente. Inserisci le fasce orarie in cui i clienti potranno visualizzare i menu e ordinare i piatti.
              <br><br>Esempio 1: per rendere prenotabili i pasti del giorno durante la colazione, impostare "Il giorno stesso" nella fascia oraria 7 - 10.
              <br><br>Esempio 2: per rendere prenotabili i pasti durante la cena, impostare "Il giorno precedente" nella fascia oraria 18 - 24.
                </p>
 
 
                </form>

<!--
             <h3 class="text-lg font-medium leading-6 text-gray-900">Ordinazione hotel</h3>
            <span 
              @click="toogle()"
              :class="this.form.enable ? 'bg-indigo-600' : 'bg-gray-200'"
              role="checkbox" 
              tabindex="0" 
              aria-checked="false" 
              class="relative flex-shrink-0 inline-block h-6 transition-colors duration-200 ease-in-out bg-gray-200 border-2 border-transparent rounded-full cursor-pointer w-11 focus:outline-none focus:shadow-outline">
            <span aria-hidden="true"  :class="this.form.enable ? 'translate-x-5' : 'translate-x-0'" class="inline-block w-5 h-5 transition duration-200 ease-in-out transform translate-x-0 bg-white rounded-full shadow"></span>
            </span>
            <p class="max-w-full mt-1 text-sm leading-5 text-gray-500">
              Per ciascun pasto indica se la prenotazione deve essere effettuata il giorno stesso oppure quello precedente. Inserisci le fasce orarie in cui i clienti potranno visualizzare i menu e ordinare i piatti.
              <br><br>Esempio 1: per rendere prenotabili i pasti del giorno durante la colazione, impostare "Il giorno stesso" nella fascia oraria 7 - 10.
              <br><br>Esempio 2: per rendere prenotabili i pasti durante la cena, impostare "Il giorno precedente" nella fascia oraria 18 - 24.
            </p>
            -->
          </div>
                
                <div class="col-span-6 lg:col-span-4">

                  <div class="flex flex-col">
                    <div class="py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                      <div class="inline-block min-w-full p-4 overflow-hidden align-middle border-b shadow sm:rounded-lg">
                        <form v-if="form.enable"  v-on:submit.prevent="onSubmit">

                          <!--

                          <div>
                            <select v-model="form.settings.selectedSource" class="block w-full py-2 pl-3 pr-10 mt-1 text-base leading-6 border-gray-300 form-select focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5">
                              <option v-for="source in sources" v-bind:value="source.value" :key="source.value">
                                {{ source.label }}
                              </option>
                            </select>
                          </div>

                          -->

                          <div class="space-y-6">
                            <div>
                              <h3 class="text-base font-medium leading-6 text-gray-900 ">Password <span class="text-sm font-normal">(facoltativa)</span></h3>
                              <p class="mt-1 text-sm text-gray-700">
                              Puoi proteggere le ordinazioni impostando una password che verrà chiesta al cliente al momento dell'invio dell'ordine. E' consigliabile aggiornarla frequentemente.
                              </p>
      
                              <div>
                                <input
                                  :class="formErrors['settings.password'] ? 'border-red-300' : ''"
                                  v-model="form.settings.password"
                                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input sm:text-sm sm:leading-5"
                                />
                                <p class="mt-1 text-xs text-red-600" v-if="formErrors['settings.password']">
                                    {{ formErrors['settings.password'][0] }}
                                </p>
                              </div>

                              
                              <h3 class="mt-4 text-base font-medium leading-6 text-gray-900">Note per i clienti</h3>

                              <div>
                                <textarea
                                  :class="formErrors['settings.notes'] ? 'border-red-300' : ''"
                                  v-model="form.settings.notes"
                                  placeholder="Inserisci qui eventuali informazioni che vuoi comunicare ai clienti in fase di ordinazione"
                                  class="block w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm form-input sm:text-sm sm:leading-5"
                                ></textarea>
                                <p class="mt-1 text-xs text-red-600" v-if="formErrors['settings.notes']">
                                    {{ formErrors['settings.notes'][0] }}
                                </p>
                              </div>
                          </div>
                          <div v-for="(type, index) in form.preferences" :key="type.id">

                            <h3 class="text-base font-medium leading-6 text-gray-900 ">{{type.name}}</h3>

                            <p class="text-sm leading-5 text-gray-500">
                              Prenotazione effettuabile:
                            </p>
                            <select v-model="type.settings.reservationType" class="block w-full py-2 pl-3 pr-10 mt-1 text-base leading-6 border-gray-300 form-select focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5">
                              <option v-for="reservationType in reservationTypes" v-bind:value="reservationType.value" :key="reservationType.value">
                                {{ reservationType.label }}
                              </option>
                            </select>
                            <p class="mt-2 text-sm leading-5 text-gray-500">
                              Fascia oraria in cui i clienti possono visulizzare il menu ed ordinare:
                            </p>
                            
                            <div class="flex mt-1">
                              <input class="block w-20 form-input sm:text-sm sm:leading-5" v-model="type.settings.startTime" type="number" min="0" max="24">
                              <div class="flex items-center justify-center w-5 text-center"> - </div>
                              <input class="block w-20 form-input sm:text-sm sm:leading-5" v-model="type.settings.endTime" type="number" min="0" max="24">
                            </div>
                            <p class="mt-1 text-xs text-red-600" v-if="formErrors['preferences.'+index+'.settings.startTime']">
                              {{formErrors['preferences.'+index+'.settings.startTime'][0]}}
                            </p>
                          </div>
                          </div>
 

                          <button
                            type="submit"
                            class="inline-flex justify-center px-4 py-2 mt-4 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700"
                          >Salva</button>

                        </form>
                      </div>
                    </div>
                  </div>
      
      </div></div>
    </div>

  </div>
</template>

<script>
import OrderSettings from "../apis/OrderSettings";

export default {
  data() {
    return {
      id: this.$route.params.id,
      tl:{},
      formErrors: {},
      form:{
          preferences:{
            
          },
          settings: {
            notes: "",
            password: ""
          }
      },
      reservationTypes:[
        {
          label: "Il giorno precedente",
          value: "0"
        },
        {
          label: "Il giorno stesso",
          value: "1"
        }
      ]
    };
  },
  mounted() {
    OrderSettings.getHotelSettings(this.id).then(response => {
      console.log(response.data);
      this.form = response.data;
      //this.form = response.data;
    });
  },
  created(){
  },
  methods: {
    toogle(){
      this.form.enable = !this.form.enable;
      this.onSubmit();
    },

    onSubmit: function() {
 
        this.formErrors = {};
        this.$store.dispatch("updateSpinner", true);
        
        OrderSettings.updateHotelSettings(this.id, this.form)
          .then(() => {
            this.$store.dispatch("updateSpinner", false);
            this.$store.dispatch("addNotification", {id: Math.floor(Math.random() * 100000), title : "Dati aggiornati", description:""});
        })
        .catch(error => {
          if (error.response.status === 422) {

            this.formErrors = error.response.data.errors;
            this.$store.dispatch("addNotification", {id: Math.floor(Math.random() * 100000), title : "Correggi gli errori", description: "", succes: false});
          }
          this.$store.dispatch("updateSpinner", false);
        });       
    }
  }
};
</script>
